import {makeDefaultEmpty} from '../../components/DefaultEmpty';

export const previewComponentsMap = {
    PreviewExtension: makeDefaultEmpty<{}>(),
} as const;
